import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'

export const List = styled.ul`
  margin: 0;
  padding: 10px 0;
  list-style: none;
  counter-reset: list;

  & > li::before {
    color: ${Theme.colors.dark_red};
    counter-increment: list;
    content: '•';
    float: left;
    margin-left: -15px;
    ${props => props.number && css`
      content: counter(list);
    `}
  }

  ${props => props.shifted && css`
    padding: 0 0 20px;
  `}
`

export const ListItem = styled.li`
  margin: 0;
  padding: 3px 3px 3px 15px;
  color: ${Theme.colors.black_new};
  ${props => props.rare && css`
    margin-bottom: 10px;
    line-height: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  `}
`

export const Component = ({ children, className, ...props }) => (
  <List className={ className } { ...props }>
    {
      React.Children.toArray(children).map((item, index) => <ListItem key={ index } { ...props }>{ item }</ListItem>)
    }
  </List>
)

Component.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string
}

export default Component
